<template>
  <div>
    <Title :pages="[{ icon: 'tachometer-alt', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <ComingSoon></ComingSoon>
    </v-container>
  </div>
</template>

<script>
import Title from "@/components/Title.vue";
import ComingSoon from "@/components/ComingSoon.vue";

export default {
  components: { Title, ComingSoon },
  data() {
    return {
      page_title: "Dashboard",
    };
  },
};
</script>
